import {AttributoValore} from '../../../common/model/attributovalore.model';
import {TipoEntitaOrganizzativaAttributo} from '../tipoentitaorganizzativaattributo/tipoentitaorganizzativaattributo.model';
import {Attributo} from '../../../common/model/attributo.model';

export class TipoEntitaOrganizzativaAttributoValore extends AttributoValore {

  constructor(public id: number,
              public target: number,
              public attributo: TipoEntitaOrganizzativaAttributo,
              public valore: string) {

    super(id, target, <Attributo>attributo, valore);

  }

}
